import type { ScheduleRow } from "@/components/DepreciationScheduleTable"

export function exportToCSV(rows: ScheduleRow[], filename = "depreciation-schedule.csv") {
  const headers = ["Year", "Beginning Book Value", "Depreciation Expense", "Accumulated Depreciation", "Ending Book Value"]
  const csvRows = [
    headers.join(","),
    ...rows.map((r) =>
      [
        r.year,
        r.beginningValue.toFixed(2),
        r.depreciation.toFixed(2),
        r.accumulatedDepreciation.toFixed(2),
        r.endingBookValue.toFixed(2),
      ].join(",")
    ),
  ]
  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
